import React from "react";

import styles from "./styles/Dashboard.module.scss";

import { Col, Row } from "react-bootstrap";
import ContinueBatches from "../Components/ContinueBatches";
import Recommendations from "../Components/Recommendations";
import TrainingCategories from "../Components/TrainingCategories";
import { useSelector } from "react-redux";
import { useGetAllCategoriesQuery, useGetAllContinueBatchesQuery, useGetRecommendedTrainingQuery } from "../../Data/services/dashboardApi";

export default function Dashboard({ setPage }) {

  // inject data
  const { data: categoryData, isLoading: categoryLoading } = useGetAllCategoriesQuery({
    refetchOnMountOrArgChange: true,
  });
  // console.log(categoryData.data);
  const allCategories = useSelector((state) => state.dashboard.allCategories) || [];
  
  const { data: recommendedData, isLoading: recommendedLoading, refetch: refetchRecommended } = useGetRecommendedTrainingQuery({
    refetchOnMountOrArgChange: true,
  });
  // console.log(recommendedData.data);
  const allRecommended = useSelector((state) => state.dashboard.allRecommended);
  
  const { data: continueData, isLoading: continueLoading } = useGetAllContinueBatchesQuery({
    refetchOnMountOrArgChange: true,
  });
  // console.log(continueData.data);
  const allContinueBatches = useSelector((state) => state.dashboard.allContinueBatches);


  return (
    <div className={styles.Dashboard}>
      <TrainingCategories data={allCategories} loading={categoryLoading} />
      <Row className="gap-2 gap-md-0">
        <Col md={4}>
          <ContinueBatches data={allContinueBatches} loading={continueLoading} />
        </Col>
        <Col md={8}>
          <Recommendations data={allRecommended} loading={recommendedLoading} refetch={refetchRecommended} />
        </Col>
      </Row>
    </div>
  );
}
